import { c as _c } from "react/compiler-runtime";
import { ApiCreateNewWave } from "@/generated/models/ApiCreateNewWave";
import { ApiWave } from "@/generated/models/ApiWave";
import { commonApiPost } from "@/services/api/common-api";
import { UseMutationResult, useMutation } from "@tanstack/react-query";

/**
 * Custom hook for wave creation mutation
 * @param options Configuration options for the mutation
 * @returns UseMutation result
 */
export const useAddWaveMutation = options => {
  const $ = _c(4);
  let t0;
  if ($[0] !== options.onError || $[1] !== options.onSettled || $[2] !== options.onSuccess) {
    t0 = {
      mutationFn: _temp,
      onSuccess: options.onSuccess,
      onError: options.onError,
      onSettled: options.onSettled
    };
    $[0] = options.onError;
    $[1] = options.onSettled;
    $[2] = options.onSuccess;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return useMutation(t0);
};
async function _temp(body) {
  return await commonApiPost({
    endpoint: "waves",
    body
  });
}